// src/services/CartManager.js
import userAxios from "../../utils/userAxios"; // for user

const BASE_URL = "/cart"; // relative to /api

const CartManager = {
  // ✅ Get all cart items for a user
  async getCartByUser(userId) {
    const response = await userAxios.get(`${BASE_URL}/view`, {
      params: { userId },
    });
    return response.data.responseData;
  },

  // ✅ Add a book to the cart
  async addToCart(userId, bookId) {
    const payload = { userId, bookId };
    try {
      const response = await userAxios.post(`${BASE_URL}/add`, payload);
      return response.data.responseData;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Failed to add to cart");
    }
  },

  // ✅ Remove specific book from cart
  async removeFromCart(userId, bookId) {
    const payload = { userId, bookId };
    const response = await userAxios.delete(`${BASE_URL}/remove`, {
      data: payload,
    });
    return response.data.responseData;
  },

  // ✅ Clear entire cart
  async clearCart(userId) {
    const response = await userAxios.delete(`${BASE_URL}/clear`, {
      params: { userId },
    });
    return response.data.responseData;
  },
};

export default CartManager;
